module.exports = __webpack_public_path__ + "static/media/vt-1.418c85b3.png";